// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"45c47668","667":"89e710b8"}[chunkId] + ".chunk.js";
};